<template>
  <v-main class="d-flex align-center justify-center h-screen">
    <v-card width="550" class="pa-4">
      <v-card-title class="screen-title">パスワード再発行</v-card-title>
      <v-card-text class="pa-4">新しいパスワードを送信しました。 </v-card-text>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn color="primary" variant="flat" href="/login"
              >ログイン画面
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </v-card>
  </v-main>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PasswordResetComplete",
});
</script>
